"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFunction;

function isFunction(val) {
  return typeof val === 'function';
}

module.exports = exports.default;